import { CSSProperties } from "react";

export type StylesClasses =
  | "container"
  | "wrapper"
  | "header"
  | "title"
  | "subtitle"
  | "section"
  | "sectionTitle"
  | "subsectionTitle"
  | "row"
  | "input"
  | "fieldHelperText"
  | "fileUpload"
  | "withHelperText"
  | "termsSection"
  | "termsCheckbox"
  | "termsText"
  | "termsLink"
  | "buttonContainer"
  | "backButton"
  | "submitButton";

const defaultStyles: Record<StylesClasses, CSSProperties> = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    padding: "32px 16px",
  },
  wrapper: {
    width: "100%",
    maxWidth: "1000px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    padding: "32px",
  },
  header: {
    marginBottom: "32px",
    textAlign: "center",
  },
  title: {
    fontSize: "28px",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: "8px",
  },
  subtitle: {
    fontSize: "16px",
    color: "#666666",
    fontWeight: 400,
  },
  section: {
    marginBottom: "32px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: "16px",
  },
  subsectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: "8px",
    marginTop: "16px",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "16px",
    marginBottom: "16px",
  },
  input: {
    display: "flex",
    flexDirection: "column",
  },
  fieldHelperText: {
    fontSize: "12px",
    color: "#999999",
    marginTop: "4px",
    fontStyle: "italic",
  },
  fileUpload: {
    marginBottom: "8px",
  },
  withHelperText: {
    position: "relative",
  },
  termsSection: {
    marginTop: "32px",
    marginBottom: "24px",
    padding: "16px",
    backgroundColor: "#f9f9f9",
    borderRadius: "4px",
    border: "1px solid #e0e0e0",
  },
  termsCheckbox: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  termsText: {
    fontSize: "14px",
    color: "#333333",
    margin: 0,
  },
  termsLink: {
    color: "#2196F3",
    cursor: "pointer",
    fontWeight: 500,
    textDecoration: "none",
    borderBottom: "1px solid #2196F3",
  },
  buttonContainer: {
    display: "flex",
    gap: "16px",
    justifyContent: "flex-end",
    marginTop: "32px",
  },
  backButton: {
    padding: "10px 24px",
    fontSize: "14px",
    fontWeight: 500,
  },
  submitButton: {
    padding: "10px 32px",
    fontSize: "14px",
    fontWeight: 500,
  },
};

export default defaultStyles;
